import React, { useState, useMemo, useCallback } from 'react';
import classnames from 'classnames';
import { Pane, IdGen, Label, NumericInput } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import I18N from '@leverege/i18n';
import { AttributeSelector } from '@leverege/ui-attributes';
import Model from "../model/StatsAggModel.js";
import S from '../Shared.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.aggregations.StatsAggEditor');
export default function StatsAggEditor(props) {
  const {
    value,
    attributes,
    onChange,
    eventData
  } = props;
  const [ids] = useState(IdGen.createIds('attr', 2));
  const values = useMemo(() => {
    return attributes.filter(attr => {
      const fieldType = attr?.fieldType || attr?.source?.attribute?.searchType;
      if (fieldType !== 'number') {
        return false;
      }
      return attr?.blueprint?.field != null && attr?.getOption?.('filterable') === true;
    }).map(attr => {
      return {
        name: attr.displayName,
        value: attr.id,
        attribute: attr
      };
    });
  }, [attributes]);
  const [bpValue, setBpVal] = useState(() => {
    return values.find(val => val.attribute.name === value?.attrName)?.attribute?.name;
  });
  const onModelChange = useValueChange(Model, props);
  const onChangeField = useCallback(evt => {
    const attribute = values.find(val => val.attribute.name === evt.value)?.attribute;
    if (!attribute) {
      return;
    }
    let nModel = Model.setField(value, attribute.source.field);
    nModel = Model.setAttrName(nModel, attribute.name);
    onChange({
      value: nModel,
      data: eventData
    });
    setBpVal(evt.value);
  }, [eventData, onChange, value, values]);
  let idx = 0;
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "editor",
    className: classnames(S.grid, S.sub),
    children: [/*#__PURE__*/_jsx(Label, {
      htmlFor: ids[idx],
      children: t('field')
    }), /*#__PURE__*/_jsx(AttributeSelector, {
      showFilter: true,
      onChange: onChangeField,
      eventData: "setField",
      id: ids[idx++],
      values: values.map(val => val.attribute),
      value: bpValue
    }), /*#__PURE__*/_jsx(Label, {
      htmlFor: ids[idx],
      children: t('missing')
    }), /*#__PURE__*/_jsx(NumericInput, {
      id: ids[idx++],
      eventData: "setMissing",
      onChange: onModelChange,
      value: Model.getMissing(value)
    })]
  });
}